import { filterFilms } from '../../../filter/utils/filter-films';
import { getAllFilms } from './get-all-films';
import { getFilmsForSite } from './get-films-for-site';
export const getFilms = (siteId, filter) => {
    const films = siteId ? getFilmsForSite(siteId) : getAllFilms();
    return filter && films ? filterFilms(filter, films) : films;
};
